import ApiProcessor from '../../processors/api-processor'
import offerStatus from '../../components/offer-status'
import OfferMixin from '../offer/offer.mixin'
import store from '~/state/store'

const isSuperAdmin = store.getters['me/isSuperAdmin']
const providers = store.getters['providers/providers']

const INACTIVE_CELL_STYLE = {
  opacity: 0.4,
}

function cellStyle(status) {
  return status ? {} : INACTIVE_CELL_STYLE
}

const TABLE_FILTERS = [
  {
    attribute: 'status',
    label: 'Status',
    type: 'select',
    icon: 'el-icon-circle-check',
    values: [
      {
        label: 'Active',
        value: 'active',
      },
      {
        label: 'Inactive',
        value: 'inactive',
      },
      {
        label: 'Expired',
        value: 'expired',
      },
    ],
  },
  isSuperAdmin &&
  {
    attribute: 'provider.id',
    type: 'select',
    label: 'Provider',
    icon: 'el-icon-document',
    values: providers.map(p => {
      return {
        value: p.id,
        label: p.name,
      }
    }),
  },
  {
    attribute: 'createdAt',
    label: 'Offer Created',
    type: 'date',
    icon: 'el-icon-time',
  },
  {
    attribute: 'retailer.name',
    type: 'string',
    icon: 'el-icon-document',
  },
  {
    attribute: 'name',
    label: 'Offer Name',
    type: 'string',
    icon: 'el-icon-document',
  },
  {
    attribute: 'type',
    label: 'Offer Type',
    type: 'select',
    icon: 'el-icon-document',
    values: [
      {
        label: 'Coupon Code',
        value: 'coupon',
      },
      {
        label: 'URL',
        value: 'url',
      },
      {
        label: 'Show and Save',
        value: 'show',
      },
    ],
  },
  {
    attribute: 'endsAt',
    label: 'Offer End Date',
    type: 'date',
    icon: 'el-icon-time',
  },
].filter(v => v)

const TABLE_COLUMNS = [
  {
    name: 'status',
    label: 'Status',
    icon: 'el-icon-circle-check',
    width: 100,
    component: (_, __, { row }) => ({
      is: offerStatus,
      props: {
        status: row.status,
      },
    }),
  },
  isSuperAdmin && {
    name: 'provider.name',
    label: 'Provider',
    icon: 'el-icon-document',
    width: 140,
  },
  {
    name: 'createdAt',
    label: 'Offer Created',
    icon: 'el-icon-time',
    format: {
      name: 'date',
      params: ['DD/MM/YYYY'],
    },
    width: 120,
    component: {
      props: {
        styleObj(_, { active }) {
          return cellStyle(active)
        },
      },
    },
  },
  {
    name: 'retailer.logo',
    label: 'Retailer Logo',
    icon: 'el-icon-document',
    width: 120,
    sortable: false,
    component: (_, __, { row }) => ({
      is: 'cell-logo',
      props: {
        showDefaultLogo: true,
        rounded: true,
        inactive: !row.active,
      },
    }),
    format(value) {
      return value ? `${value}//-/preview/40x40/-/quality/best/` : ''
    },
  },
  {
    name: 'retailer.name',
    label: 'Retailer Name',
    icon: 'el-icon-document',
    width: 200,
    component: {
      props: {
        styleObj(_, { active }) {
          return cellStyle(active)
        },
      },
    },
  },
  {
    name: 'name',
    label: 'Offer Name',
    icon: 'el-icon-document',
    width: 200,
    component: {
      props: {
        styleObj(_, { active }) {
          return cellStyle(active)
        },
      },
    },
  },
  {
    name: 'type',
    label: 'Offer Type',
    icon: 'el-icon-document',
    width: 130,
    component: {
      props: {
        styleObj(_, { active }) {
          return cellStyle(active)
        },
      },
    },
    format(_, row) {
      return OfferMixin.methods.offerTypeName(row.type)
    },
  },
  {
    name: 'locations',
    label: 'Participating Location(s)',
    icon: 'el-icon-document',
    format(_, row) {
      const { locations } = row
      if (!locations || !locations.length) return ''

      return locations.length === 1
        ? locations[0].name
        : `${locations.length} locations`
    },
    component: {
      props: {
        styleObj(_, { active }) {
          return cellStyle(active)
        },
      },
    },
  },
  {
    name: 'endsAt',
    label: 'Offer End Date',
    icon: 'el-icon-document',
    format: {
      name: 'date',
      params: ['DD/MM/YYYY'],
    },
    width: 120,
    component: {
      props: {
        styleObj(_, { active }) {
          return cellStyle(active)
        },
      },
    },
  },
].filter(v => v)

export default component => {
  return {
    processor: new ApiProcessor({
      component,
      path: 'offers',
      initialDataQuery: { pageSize: 25 },
    }),
    filters: TABLE_FILTERS,
    columns: TABLE_COLUMNS,
    tableName: 'offers',
  }
}
